<template>
    <div class="flex flex-col h-[95%] gap-3">
        <ai-grid-edit-wrapper
            ref="gridEditRef"
            :args="args"
            :meta="meta"
            @onAddClickEvent="handleAddClickEvent"
            @grid-edit-wrapper-mounted="onGridEditWrapperMounted"
        >
        </ai-grid-edit-wrapper>
    </div>
</template>

<script setup>
import AiGridEditWrapper from '@/components/wrappers/ai-grid-edit-wrapper.vue';
import { getContractCard } from '@/service/contract-service';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';
import { ref } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const cardInfo = ref();
const gridEditRef = ref();
const noteBookInstance = ref();
const gridInstance = ref();

const onGridEditWrapperMounted = async () => {
    cardInfo.value = await getContractCard(route.params.id);
    args.select.select_args.kod_dog = cardInfo.value.data?.kod_dog;
    noteBookInstance.value = {
        refresh: gridEditRef.value?.ref.setDataSource,
        userData: () => {},
        userSettings: () => {},
    };
    setActiveViewInfo(noteBookInstance.value);
    await setViewData();
    gridInstance.value = gridEditRef.value.ref.gridInstance;
};

const handleAddClickEvent = () => {
    const changes = gridInstance.value.option('editing.changes') || [];
    const currentDate = new Date();
    currentDate.toLocaleString('ru-RU', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
    });
    const updatedChanges = changes.map(change => {
        if (change.type === 'insert' && !change.data.kod_dog) {
            return {
                ...change,
                data: {
                    ...change.data,
                    datevv: currentDate,
                    kod_dog: cardInfo.value.data.kod_dog,
                },
            };
        }
        return change;
    });

    gridInstance.value.option('editing.changes', updatedChanges);
};

const args = {
    select: {
        meta_args: {
            select: 'dog.f_kr_dogovor_prim_select',
        },
        select_args: {
            kod_dog: null,
        },
    },
};

const meta = {
    keyExpr: 'kod_prim',
    wordWrapEnabled: true,
    scrollingMode: 'virtual',
    focusedRowEnabled: true,
    allowSelectAll: true,
    viewId: 'kr-dogovor-prim-view',
    api: {
        select: 'dog./dog/kr-dogovor-prim-select/get',
        save: 'dog./dog/kr-dogovor-prim-save/set',
    },
    columns: [
        {
            name: 'kod_dog',
            caption: 'Код договора',
            dataField: 'kod_dog',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: -1,
            visible: false,
        },
        {
            name: 'kod_prim',
            caption: 'Код',
            dataField: 'kod_prim',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 0,
            visible: false,
        },
        {
            name: 'prim',
            caption: 'Текст записной книжки',
            dataField: 'prim',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 1,
            visible: true,
        },
        {
            name: 'datevv',
            caption: 'Дата ввода',
            dataField: 'datevv',
            allowEditing: true,
            dataType: 'date',
            format: {
                formatter: value => {
                    if (!value) return '';
                    const date = new Date(value);
                    date.toLocaleString('ru-RU', {
                        day: 'numeric',
                        month: 'numeric',
                        year: 'numeric',
                    });
                    const day = date.getDate().toString().padStart(2, '0');
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}.${month}.${year}`;
                },
            },
            calculateDisplayValue: rowData => {
                if (!rowData.datevv) return ' ';
                const date = new Date(rowData.datevv);
                return date.toLocaleString('ru-RU', {
                    day: 'numeric',
                    month: 'numeric',
                    year: 'numeric',
                });
            },
            validationRules: [
                {
                    type: 'custom',
                    message: 'Дата не может быть меньше 01.01.1900',
                    validationCallback: e => {
                        if (!e.value) return true;
                        return new Date(e.value) >= new Date(1900, 0, 1);
                    },
                },
            ],
        },
        {
            name: 'kod_area',
            caption: 'Область применения',
            dataField: 'kod_area',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'name',
            },
            component: {
                name: 'rk-area-view',
                text: 'name',
                id: 'kod_area',
            },
            index: 4,
            visible: true,
        },
        {
            name: 'name',
            caption: 'name',
            dataField: 'name',
            allowEditing: false,
            editor: {
                type: 'ai-dropdown-box',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 5,
            visible: false,
        },
        {
            name: 'd_m',
            caption: 'Дата корректировки',
            dataField: 'd_m',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 6,
            visible: true,
        },
    ],
};
</script>

<style scoped></style>
